module.exports = __webpack_public_path__ + "static/home-intro-high.9a7a7053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/welcome-block/home-intro-high.jpg
// module id = 125
// module chunks = 35783957827783 122595392396565